import { useEffect, useState } from "react";
import { useSearchParams } from "react-router-dom";
import { Search } from "lucide-react";
import { api } from "../lib/api";
import { Empty, Loading, PageHeader, Panel } from "../components/common";
import { BerthSheet } from "../components/BerthSheet";
import { Input } from "../components/ui/input";
import { Tabs, TabsList, TabsTrigger } from "../components/ui/tabs";
import { Sheet, SheetContent, SheetTitle } from "../components/ui/sheet";

export default function MarinaBerths() {
  const [mode, setMode] = useState("posto");
  const [q, setQ] = useState("");
  const [items, setItems] = useState(null);
  const [params, setParams] = useSearchParams();
  const [open, setOpen] = useState(params.get("open"));
  const [tick, setTick] = useState(0);
  useEffect(() => { if (params.get("open")) { setOpen(params.get("open")); setParams({}, { replace: true }); } }, [params, setParams]);

  useEffect(() => {
    if (mode === "barca" && !q.trim()) { setItems([]); return; }
    const t = setTimeout(() => {
      const path = mode === "posto" ? `/marina/berths?q=${encodeURIComponent(q)}` : `/marina/boats/search?q=${encodeURIComponent(q)}`;
      api(path).then((d) => setItems(d.items || [])).catch(() => setItems([]));
    }, 300);
    return () => clearTimeout(t);
  }, [mode, q, tick]);

  return (
    <div>
      <PageHeader subtitle="Cerca per pontile/numero o per barca" title="Posti barca" />
      <div className="flex flex-wrap gap-4 items-center mb-6">
        <Tabs value={mode} onValueChange={(v) => { setMode(v); setQ(""); }}><TabsList><TabsTrigger value="posto" data-testid="berths-mode-posto">Posti barca</TabsTrigger><TabsTrigger value="barca" data-testid="berths-mode-barca">Cerca barca</TabsTrigger></TabsList></Tabs>
        <div className="relative flex-1 max-w-sm"><Search className="w-4 h-4 absolute left-3 top-3 text-slate-400" /><Input value={q} onChange={(e) => setQ(e.target.value)} placeholder={mode === "posto" ? "Es. P oppure 12" : "Nome barca"} className="pl-9 bg-white" data-testid="berths-search-input" /></div>
      </div>
      {!items ? <Loading /> : items.length === 0 ? <Empty title={mode === "posto" ? "Nessun posto" : "Nessuna barca"} text={mode === "posto" ? "Modifica la ricerca" : "Digita il nome della barca"} /> : (
        <div className="grid sm:grid-cols-2 lg:grid-cols-4 gap-3" data-testid="berths-list">{items.map((it) => {
          const id = it.berth_id || it.id;
          return (
            <button key={it.id} onClick={() => setOpen(id)} className="text-left" data-testid={`berth-item-${id}`}>
              <Panel className="panel-hover !p-4">
                <div className="flex justify-between items-center"><span className="font-display font-bold text-lg text-[var(--navy)]">{it.pontile} - {it.numero}</span>
                  {mode === "posto" && <span className={`w-2.5 h-2.5 rounded-full ${it.occupied ? "bg-red-500" : "bg-emerald-500"}`} />}</div>
                <p className="text-sm text-slate-600 mt-1">{mode === "posto" ? (it.occupied ? it.boat_name || "Occupato" : "Libero") : it.nome_barca || it.boat_name}</p>
                {it.dimensione && <p className="text-xs text-slate-400 mt-1">{it.dimensione}</p>}
              </Panel>
            </button>);
        })}</div>)}
      <Sheet open={!!open} onOpenChange={(v) => !v && setOpen(null)}>
        <SheetContent className="w-full sm:max-w-xl overflow-y-auto"><SheetTitle className="sr-only">Scheda posto</SheetTitle>
          {open && <BerthSheet id={open} onPresenceSaved={() => setTick((t) => t + 1)} />}
        </SheetContent>
      </Sheet>
    </div>
  );
}
